export interface SearchHighlightSegment {
  isHighlighted: boolean;
  startIndex: number;
  text: string;
}

const escapeSearchHighlightToken = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const getSearchHighlightTokens = (value: string) => Array.from(new Set(
  value
    .trim()
    .split(/\s+/)
    .filter(token => token.length >= 2)
)).sort((leftToken, rightToken) => rightToken.length - leftToken.length);

export const getSearchHighlightSegments = (text: string, highlightText: string): SearchHighlightSegment[] => {
  const tokens = getSearchHighlightTokens(highlightText);

  if (!tokens.length) {
    return [{ isHighlighted: false, startIndex: 0, text }];
  }

  const highlightPattern = new RegExp(`(${tokens.map(escapeSearchHighlightToken).join('|')})`, 'gi');
  const normalizedTokens = new Set(tokens.map(token => token.toLocaleLowerCase()));

  let startIndex = 0;

  return text
    .split(highlightPattern)
    .filter(segment => segment.length > 0)
    .map(segment => {
      const currentStartIndex = startIndex;
      startIndex += segment.length;

      return {
        isHighlighted: normalizedTokens.has(segment.toLocaleLowerCase()),
        startIndex: currentStartIndex,
        text: segment,
      };
    });
};
